import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    downloadAppDescription:
      'Stay updated on the progress of your file and much more. Available on iOS and Android.',
    downloadAppHeading:
      'In the meantime, you can already download the Shine mobile app.',
  },
  fr: {
    downloadAppDescription:
      'Soyez prévenu de l’avancé de votre dossier et bien plus encore. Disponible sur iOS et Android.',
    downloadAppHeading:
      'En attendant, vous pouvez déjà télécharger l’application Shine sur votre mobile.',
  },
} as const);
